// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"adccf154","455":"6d023cec","977":"47725be5"}[chunkId] + ".chunk.js";
};